module.exports = __webpack_public_path__ + "img/Partner_Feixiaohao.2a42e176.svg";